module.exports = __webpack_public_path__ + "static/media/jazzcash.42b0510a.png";